import Base from './Base';
import Tall from './Tall';
import Upper from './Upper';

export default {
  Base,
  Tall,
  Upper
};
